import helpRecipientFA from './fa/fa.json'

const HelpRecipientMessages = {
  fa: { ...helpRecipientFA },
}

export default HelpRecipientMessages
